import * as E from 'fp-ts/Either';
import { flow } from 'fp-ts/function';
import * as t from 'io-ts';
import { failure } from 'io-ts/PathReporter';
export function cast(codec) {
    return flow(codec.decode, E.getOrElse(function (errors) {
        throw new Error(failure(errors).join('\n'));
    }));
}
export var int = cast(t.Int);
